import { render, staticRenderFns } from "./IndicatorsYellow.vue?vue&type=template&id=4a483400&scoped=true&"
import script from "./IndicatorsYellow.vue?vue&type=script&lang=js&"
export * from "./IndicatorsYellow.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsYellow.vue?vue&type=style&index=0&id=4a483400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a483400",
  null
  
)

export default component.exports